<p-toast position="bottom-center"></p-toast>

<p-card>
  <ng-container *transloco="let t; read: 'all-data-user-editor'">
    <p-confirmDialog
      #dialog
      icon="pi pi-exclamation-triangle"
      role="alertdialog"
      [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
      [closable]="false"
      [header]="isUserDisabled ? t('confirmEnableTitle') : t('confirmDisableTitle')"
      [message]="
        isUserDisabled
          ? t('confirmEnableMessage', { displayName: disPlayedUsername })
          : t('confirmDisableMessage', { displayName: disPlayedUsername })
      "
      [ngStyle]="{ 'word-break': 'break-word', 'white-space': 'pre-wrap' }"
    >
      <ng-template pTemplate="footer">
        <button class="p-button-text" icon="pi pi-times" pButton [label]="t('no')" (click)="dialog.reject()"></button>
        <button
          class="p-button-danger p-button-text"
          icon="pi pi-check"
          pButton
          [label]="t('yes')"
          (click)="dialog.accept()"
        ></button>
      </ng-template>
    </p-confirmDialog>

    <form *ngrxLet="form.controls as controls" class="all-data-user-editor__form" [formGroup]="form">
      <label *ngrxLet="controls.firstName as firstName" class="all-data-user-editor__form-field">
        <span>{{ t('firstName.label') }}</span>

        <input formControlName="firstName" pInputText />

        <app-form-field-help [control]="firstName">
          <ng-container form-field-help-errors>
            <div *ngIf="firstName.errors?.required">
              {{ t('firstName.errorRequired') }}
            </div>
          </ng-container>
        </app-form-field-help>
      </label>

      <label *ngrxLet="controls.lastInitial as lastInitial" class="all-data-user-editor__form-field">
        <span>{{ t('lastInitial.label') }}</span>

        <input formControlName="lastInitial" pInputText />

        <app-form-field-help [control]="lastInitial">
          <ng-container form-field-help-errors>
            <div *ngIf="lastInitial.errors?.required">
              {{ t('lastInitial.errorRequired') }}
            </div>
          </ng-container>
        </app-form-field-help>
      </label>

      <div class="all-data-user-editor__form-field">
        <span>{{ t('email.label') }}</span>
        <div class="p-inputgroup">
          <input
            class="all-data-user-editor__readonly-input w-full"
            pInputText
            [value]="obj.userData.getNotificationEmail()"
          />
          <p-button
            icon="pi pi-pencil"
            styleClass="p-button-secondary"
            [ariaLabel]="t('changeEmail')"
            [disabled]="isUserDisabled"
            (click)="openChangeEmailDialog()"
          >
          </p-button>
        </div>
        <span class="all-data-user-editor__field-hint">{{ t('email.hint') }}</span>
      </div>

      <div class="all-data-user-editor__form-field">
        <span>{{ t('password.label') }}</span>
        <div class="p-inputgroup">
          <input class="all-data-user-editor__readonly-input w-full" pInputText [value]="'********'" />
          <p-button
            icon="pi pi-pencil"
            styleClass="p-button-secondary"
            [ariaLabel]="t('changePassword')"
            [disabled]="isUserDisabled"
            (click)="openChangePasswordDialog()"
          >
          </p-button>
        </div>
        <span class="all-data-user-editor__field-hint">{{ t('password.hint') }}</span>
      </div>

      <label *ngrxLet="controls.e164Phone as e164Phone" class="all-data-user-editor__form-field">
        <span>{{ t('usTelephone.label') }}</span>

        <p-inputMask formControlName="e164Phone" mask="(999) 999-9999" styleClass="inputfield w-full" [unmask]="true">
        </p-inputMask>

        <app-form-field-help [control]="e164Phone">
          <ng-container form-field-help-hint>
            {{ t('usTelephone.hint') }}
          </ng-container>

          <ng-container form-field-help-errors>
            <div *ngIf="e164Phone.errors?.required">
              {{ t('usTelephone.errorRequired') }}
            </div>
            <div *ngIf="e164Phone.errors?.usLocalPhone">
              {{ t('usTelephone.errorInvalid') }}
            </div>
          </ng-container>
        </app-form-field-help>
      </label>

      <label *ngrxLet="controls.roles as roles" class="all-data-user-editor__form-field">
        <span>{{ t('roles.label') }}</span>

        <p-multiSelect
          class="all-data-user-editor__dropdown"
          formControlName="roles"
          [defaultLabel]="t('noRole')"
          [maxSelectedLabels]="2"
          [options]="rolesOptions$ | async"
          [selectedItemsLabel]="'{0} ' + t('roles.selectedRolesSuffix') | lowercase"
          [showHeader]="false"
        >
          <ng-template pTemplate="item" let-item>
            <div class="all-data-user-editor__dropdown-item">
              <span>{{ item.label }}</span>
              <span class="all-data-user-editor__dropdown-item-description">{{ item.description }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
      </label>

      <label *ngrxLet="controls.orgNote as orgNote" class="all-data-user-editor__form-field">
        <span>{{ t('orgNote.label') }}</span>

        <textarea formControlName="orgNote" pInputTextarea></textarea>

        <app-form-field-help [control]="orgNote">
          <ng-container form-field-help-hint>
            {{ t('orgNote.hint') }}
          </ng-container>

          <ng-container form-field-help-errors>
            <div *ngIf="orgNote.errors?.maxlength">
              {{ t('orgNote.errorMaxlength') }}
            </div>
          </ng-container>
        </app-form-field-help>
      </label>
    </form>

    <div class="flex justify-content-start gap-2 mt-4">
      <p-button
        styleClass="p-button-primary p-button-text"
        [ariaLabel]="t('cancel')"
        [label]="t('cancel')"
        (click)="cancelEdit.emit()"
      >
      </p-button>
      <p-button
        styleClass="p-button-danger p-button-text"
        [ariaLabel]="t('delete')"
        [disabled]="deleteDialogOpened || deleteProcessing || loggedInUserIsOrgAdmin !== true"
        [label]="t('delete')"
        [loading]="deleteProcessing"
        (click)="confirmAndDelete()"
      >
      </p-button>
      <p-button
        styleClass="p-button-secondary p-button-text"
        [ariaLabel]="isUserDisabled ? t('enable') : t('disable')"
        [label]="isUserDisabled ? t('enable') : t('disable')"
        [loading]="disableOrEnableProcessing"
        (click)="onClickDisableOrEnableUser()"
      >
      </p-button>
      <p-button
        styleClass="p-button-primary"
        [ariaLabel]="t('save')"
        [disabled]="uploadProcessing || isUserDisabled || form.invalid"
        [label]="t('save')"
        [loading]="uploadProcessing"
        (click)="saveEditUser()"
      ></p-button>
    </div>
  </ng-container>
</p-card>
